// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState, useRef, useEffect, Fragment} from 'react';
import cn from 'classnames';
import {Button} from '../../../../hola/pub/lib/button';
import Icon_arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import {perr} from 'hola_pub_util';
// @ts-ignore
import {Gradient} from '../../../../hola/pub/lib/gradient.js';
import {use_qs} from '../../../../hola/pub/lib/use_qs';
import {if_set} from 'zutil';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import anim_styles from '../../ui/animation.module.less';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {use_show_promo} from '../free_proxy/use_show_promo';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';
import {Input} from '../../../../hola/pub/lib/input';
import {Lottie} from '../../../../shared/ui/lottie';

import styles from './index.module.less';

interface i_hero_props {
    title?: string;
    title_tag?: string;
    subtitle?: string;
    cta?: string;
    after_cta?: string;
}

interface i_hero_editor_props {
    value: i_hero_props;
    on_change: (v: i_hero_props)=>void;
    on_cancel: ()=>void;
}

export const HP_gradient_hero_editor = (props: i_hero_editor_props)=>{
    const [state, set_state] = useState<i_hero_props>(props.value || {});
    useEffect(()=>{
        set_state(props.value);
    }, [props.value]);
    return <div>
        <Input size={'sm'} label={'title (html)'} value={state.title || ''}
          on_change={v=>set_state({...state, title: v})}/>
        <Title_header_select value={state.title_tag} on_select={v=>
          set_state({...state, title_tag: v})} />
        <Input size={'sm'} label={'subtitle (html)'} value={state.subtitle
          || ''} on_change={v=>set_state({...state, subtitle: v})} />
        <Input size={'sm'} label={'cta'} value={state.cta || ''}
          on_change={v=>set_state({...state, cta: v})} />
        <Input size={'sm'} label={'after_cta'} value={state.after_cta || ''}
          on_change={v=>set_state({...state, after_cta: v})}/>
        <br />
        <Button caption={'Save'} size={'sm'}
          on_click={()=>props.on_change(state)} />
        <Button caption={'Cancel'} size={'sm'}
          on_click={()=>props.on_cancel()} />
    </div>;
};

export const HP_gradient_hero = (props: i_hero_props)=>{
    const {theme} = useContext(Settings_context);
    const {title, title_tag, subtitle, cta, after_cta} = props;
    const {show_promo} = use_show_promo();
    const qs = use_qs();
    const gradient_ref = useRef();
    const hero_ref = useRef<HTMLDivElement>();
    const {T, t} = use_translation_v({no_defaults: true});
    useEffect(()=>{
        if (!gradient_ref.current || !hero_ref.current)
            return;
        const vars = {};
        if_set(qs.color1 && '#'+qs.color1, vars, 'gradient-color-1');
        if_set(qs.color2 && '#'+qs.color2, vars, 'gradient-color-2');
        if_set(qs.color3 && '#'+qs.color3, vars, 'gradient-color-3');
        if_set(qs.color4 && '#'+qs.color4, vars, 'gradient-color-4');
        if_set(qs.gradient_op && +qs.gradient_op/100, vars, 'gradient_op');
        if_set(qs.animation_op && +qs.animation_op/100, vars, 'animation_op');
        if_set(qs.underlay_op && +qs.underlay_op/100, vars, 'underlay_op');
        if_set(qs.content_op && +qs.content_op/100, vars, 'content_op');
        if_set(qs.gradient_pos, vars, 'gradient_pos');
        if_set(qs.animation_pos, vars, 'animation_pos');
        if_set(qs.underlay_pos, vars, 'underlay_pos');
        Object.keys(vars).forEach(k=>{
            hero_ref.current.style.setProperty(`--${k}`, vars[k]);
        });
        if (qs.no_animation)
            return;
        const on_interact = ()=>{
            const gradient = new Gradient();
            // @ts-ignore
            gradient.initGradient('#gradient-canvas');
            window.removeEventListener('scroll', on_interact);
            window.removeEventListener('mousemove', on_interact);
        };
        window.addEventListener('scroll', on_interact);
        window.addEventListener('mousemove', on_interact);
    }, [gradient_ref.current, hero_ref.current]);
    const hero_cls = cn(styles.gradient_hero, {
        [styles.no_animation]: qs.no_animation,
    });
    const caption =
        cta ? t(cta) : show_promo ? 'Try now for free' : 'Try now';
    return <div ref={hero_ref} className={hero_cls}>
      <canvas ref={gradient_ref} id="gradient-canvas" data-transition-in/>
      <div className={cn(theme.container, styles.hero)}>
        <div className={cn(styles.hero_top, anim_styles.hero_showup_1)}>
          <p className={cn(theme.mono12, styles.uptime)}>
            <Lottie autoplay loop width="20px" height="14px"
              src={toolip_img_url('animation/uptime.json')}/>
            <span><T>Uptime: <b>99.9%</b></T></span>
          </p>
        </div>
        {/* <div className={styles.hero_text_wrapper}>
          <h1 className={cn(styles.hero_title, anim_styles.hero_showup_2)}>
            <T>Lightning-Fast Proxies.<br/> Global IP Variety.</T></h1>
          <p className={cn(theme.u1, styles.hero_text,
            anim_styles.hero_showup_2)}><T>Get the perfect proxy, built for
              your needs</T></p>
          <Button caption={<Fragment><T>{caption}</T> <Icon_arrow_right/>
            </Fragment>}
            size={'lg'} no_jump to={'/dashboard'} fit
            on_click={()=>{
              perr({id: 'toolip_homepage_get_started_top_click'});
            }} cls={cn(styles.hero_cta, anim_styles.hero_showup_3)}
          />
          <p className={cn(theme.p4, theme.med, styles.hero_cta_text,
            anim_styles.hero_showup_3)}>
            <T>Free proxies | No credit card required</T>
          </p>
        </div> */}
        <div className={styles.hero_text_wrapper}>
          {title ? <Dynamic_heading className={cn(styles.hero_title,
            anim_styles.hero_showup_2)}
            tag={title_tag}
            dangerouslySetInnerHTML={{__html: t(title)}}/>
            : <h1 className={cn(styles.hero_title, anim_styles.hero_showup_2)}>
              <T>Lightning-Fast Proxies.<br /> Global IP Variety.</T>
            </h1>}
          {subtitle ? <p className={cn(theme.u1, styles.hero_text,
            anim_styles.hero_showup_2)}
              dangerouslySetInnerHTML={{__html: t(subtitle)}} />
            : <p className={cn(theme.u1, styles.hero_text,
              anim_styles.hero_showup_2)}><T>Get the perfect proxy, built for
                your needs</T></p>}
          <Button caption={<Fragment><T>{caption}</T> <Icon_arrow_right />
            </Fragment>}
            size={'lg'} no_jump to={'/dashboard'} fit
            on_click={()=>{
              perr({id: 'toolip_homepage_get_started_top_click'});
            }} cls={cn(styles.hero_cta, anim_styles.hero_showup_3)}
          />
          <p className={cn(theme.p4, theme.med, styles.hero_cta_text,
            anim_styles.hero_showup_3)}>
            <T>{after_cta || 'Free proxies | No credit card required'}</T>
          </p>
        </div>
      </div>
    </div>;
};

